import { useContext, useEffect, useState } from "react";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import { useLocation, useNavigate } from "react-router-dom";
import { encodeQueryParams } from "../../../../../utils/EncodeDecodeQueryParams";

export const useAPIGetSedangProses = (props) => {
  const uiContext = useContext(UiContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { filterValue } = props;

  const { requestGet, requestDelete, loading } = useAPIRequest();

  const [paging, setPaging] = useState({
    page: 1,
    take: 10,
    filter: "",
    total: 0,
  });
  const [listDataSedangProses, setListDataSedangProses] = useState([]);

  //  API call section

  const fetchListSedangProses = async ({
    page = 1,
    take = 10,
    filter,
    filterValue: _filterValue,
  }) => {
    const _filter =
      (filter ?? getFilter(_filterValue))
      + `;tanggal:!=:Null;data_kendaraan.data_kendaraan_jenis.nama:=:Trado`;

    return requestGet({
      fullUrl: `/api/audit/auditkendaraan/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: "tanggal",
        order_method: "DESC",
        with_kendaraan: 1,
        with_trailer: 1,
        with_verif_dibuat: 1,
        with_verif_diketahui: 1,
        with_verif_diteliti: 1,
      },
      onSuccess: async ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListDataSedangProses(
          data.map((item, index) => ({
            ...item,
            no: (page - 1) * take + index + 1,
          }))
        );

        const urlFilter = _filterValue
          ? { ..._filterValue }
          : { ...filterValue };
        urlFilter.page = paging.page;
        urlFilter.take = paging.take;

        const encodedUrlFilter = await encodeQueryParams(
          JSON.stringify(urlFilter)
        );

        navigate(`${location.pathname}?key=${encodedUrlFilter}`, {
          replace: true,
        });
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async ({ id }) => {
    return requestDelete({
      fullUrl: "/api/audit/auditkendaraan/delete",
      ids: [id],
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
      onSuccess: ({ message, data }) => {
        const newListData = listDataSedangProses.filter(
          (item) => item.id !== id
        );
        newListData.forEach((item, index) => {
          item.no = (paging.page - 1) * paging.take + index + 1;
        });
        setListDataSedangProses(newListData);

        uiContext.showSuccessMsg("Success", message);
      },
    });
  };

  // other function section

  const getFilter = (filterValueInput) => {
    const filters = [];

    const _filterValue = filterValueInput ?? filterValue;

    filters.push("verif_diteliti_datetime:=:Null||verif_dibuat_datetime:=:Null||verif_diteliti_datetime:=:Null");

    if (_filterValue.data_kendaraan && _filterValue.data_kendaraan.id > 0) {
      filters.push(`kendaraan_id:=:${_filterValue.data_kendaraan.id}`);
    }

    return filters.join(";");
  };

  //   hanlde ui event section

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListSedangProses({
      page: newPage,
      take: newTake,
      filter: paging.filter,
    });
  };

  return {
    loading,
    paging,
    fetchListSedangProses,
    deleteData,
    listDataSedangProses,
    handleOnPage,
  };
};
